import React from 'react';
import { Icon } from './Icon.js';
export const IconHammer = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9.5 11L8.5 22L15.5 22L14.5 11", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 11V3H15L21 7V11H3Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconHammer.js.map